module.exports = __webpack_public_path__ + "static/media/h5_yoga_pic5.45cc95b7.png";